module.exports = __webpack_public_path__ + "static/media/partner_02.5ac4f905.png";